import React, { useEffect, useState, useRef, useMemo } from "react";
import Loader from "../component/Loader";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { getData, postData } from "../store/utils";
import Swal from "sweetalert2";
import { useDebounce } from 'use-debounce';
import { useParams, useHistory } from "react-router-dom";
import { ChevronDown, Plus, ChevronUp, Pencil, X, Eye, EyeOff, Search, Bell, Settings, User, Grid, } from 'lucide-react';
import Select from "react-select";

function VendorDetails() {
    const [isLoadingOn, setIsLoadingOn] = useState(false);
    const { id } = useParams();
    const [vendorList, setVendorList] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [vendorActivity, setVendorActivity] = useState(null);
    const [text, setText] = useState('');
    const [value] = useDebounce(text, 1000);
    const [activeTab, setActiveTab] = useState("Overview");
    const [collapsedSections, setCollapsedSections] = useState({});
    const [editCurrency, setEditCurrency] = useState(false);
    const [editLanguage, setEditLanguage] = useState(false);
    const [showContactModal, setShowContactModal] = useState(false); 
    const [showBankDetailsModal, setShowBankDetailsModal] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPortalAccessEnabled, setIsPortalAccessEnabled] = useState('');
    const [addressJustSaved, setAddressJustSaved] = useState(false);
    const [salutationData, setContactSalutationData] = useState('');
    const [formErrors, setFormErrors] = useState({});
    const [firstNameContact, setContactFirstName] = useState('');
    const [lastNameContact, setContactLastName] = useState('');
    const [emailContact, setContactEmail] = useState('');
    const [workPhoneContact, setContactWorkPhone] = useState('');
    const [mobileContact, setContactMobile] = useState(''); 
    const [designationContact, setContactDesignation] = useState('');
    const [departmentContact, setContactDepartment] = useState('');
    const [skypeLinkContact, setContactSkypeLink] = useState('');
    const [showAccountNumber, setShowAccountNumber] = useState(false);
    const [showConfirmNumber, setShowConfirmNumber] = useState(false);
    const [visibleAccounts, setVisibleAccounts] = useState({});
    const [modalType, setModalType] = useState('billing');
    const [billingAddress, setBillingAddress] = useState({});
    const [shippingAddress, setShippingAddress] = useState({});
    const [searchText, setSearchText] = useState('');
    const history = useHistory();
    const [searchValue] = useDebounce(searchText, 1000);
    const [bankInputErrors, setBankInputErrors] = useState({});
    const [showTopMessage, setShowTopMessage] = useState(false);
    const userInfo = JSON.parse(localStorage.getItem("USER_DATA"));
    const employeeId = userInfo.employeeId;
    const [formData, setFormData] = useState({
        salutation: "",
        firstName: "",
        lastName: "",
        companyName: "",
        displayName: "",
        email: "",
        phoneNumber: "",
        mobileNumber: "",
        panNumber: "",
        gstNumber: "",
        uinNumber: "",
        isMsmeRegistered: "No",
        udyamRegistrationType: "",
        udyamRegistrationNumber: "",
        department: "",
        designation: "",
        currency: "",
        paymentTerms: "",
        tds: 0,
        isPortalAccessEnabled: "No",
        language: "",
        documentPath: [],
        websiteUrl: "",
        tweeterLink: "",
        facebookLink: "",
        skypeLink: "",
        remarks: "",
        billingCountry: 'India',
        billingAddessLine1: '',
        billingAddessLine2: '',
        billingCity: '',
        billingState: '',
        billingPincode: '',
        billingPhoneNumber: '',
        billingFaxNumber: '',
        shippingCountry: 'India',
        shippingAddessLine1: '',
        shippingAddessLine2: '',
        shippingCity: '',
        shippingState: '',
        shippingPincode: '',
        shippingPhoneNumber: '',
        shippingFaxNumber: '',
        createdBy: employeeId,
        updatedBy: employeeId,
        contactPersons: [
            {
            salutation: "",
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            mobileNumber: "",
            skypeLink: "",
            designation: "",
            department: ""
            }
        ],
        bankDetails: [
            {
            accountHolderName: "",
            bankName: "",
            accountNumber: "",
            confirmAccountNumber: "",
            ifscCode: ""
            }
        ]
    }); 

    const formatDateTime = (isoDateString) => {
        const date = new Date(isoDateString);
        const pad = (num) => String(num).padStart(2, '0');
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
      
    const [addressInput, setAddressInput] = useState({
        country: 'India',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        pinCode: '',
        phoneNumber: '',
        faxNumber: ''
    });

    const [bankInput, setBankInput] = useState({
        accountHolderName: "",
        bankName: "",
        accountNumber: "",
        confirmAccountNumber: "",
        ifscCode: ""
    });

    const CurrencyOptions = [
        { value: 'AED', label: 'AED-UAE Dhirham' },
        { value: 'AUD', label: 'AUD-Australian Dollar' },
        { value: 'BND', label: 'BND-Brunei Dollar' },
        { value: 'CAD', label: 'CAD-Canadian Dollar' },
        { value: 'CNY', label: 'CNY-Yuan Renminbi' },
        { value: 'EUR', label: 'EUR-Euro' },
        { value: 'GBP', label: 'GBP-Pound Sterling' },
        { value: 'INR', label: 'INR-Indian Rupee' },
        { value: 'JPY', label: 'JPY-Japanese Yen' },
        { value: 'SAR', label: 'SAR-Soudi Riyal' },
        { value: 'USD', label: 'USD-United States Dollar' },
        { value: 'ZAR', label: 'ZAR-South Afreican Rand' },
    ];
      
    const languageOptions = [
        { value: "english", label: "English" },
        { value: "spanish", label: "Spanish" },
        { value: "french", label: "French" },
        { value: "german", label: "German" },
        { value: "chinese", label: "Chinese" },
    ];

    const salutationOptions = [
        { value: 'mr', label: 'Mr.' },
        { value: 'mrs', label: 'Mrs.' },
        { value: 'ms', label: 'Ms.' },    
        { value: 'miss', label: 'Miss' }, 
        { value: 'dr', label: 'Dr.' },
    ];

    const fieldLabels = {
        accountHolderName: "Account Holder Name",
        bankName: "Bank Name",
        accountNumber: "Account Number",
        confirmAccountNumber: "Confirm Account Number",
        ifscCode: "IFSC Code"
    };

    useEffect(() => {
        if (searchValue) {
            searchVendorList(searchValue);
        }
    }, [searchValue]);

    async function searchVendorList(searchText) {
        setIsLoadingOn(true);
        const tempData = await getData(`inventory/getVendor?vendorName=${searchText}`);
        setIsLoadingOn(false);

        if (tempData?.statusCode === 200) {
            const records = tempData?.data?.records;
            if (Array.isArray(records)) {
                setVendorList(records || []);
            } else {
                setVendorList([]);
            }
        } else {
            setVendorList([]); 
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors?.msg || "Something went wrong!!!"
            });
        }
    }

    useEffect(() => {
        fetchVendorDetails(id);
    }, [id]);

    async function fetchVendorDetails(vendorId) {
        setIsLoadingOn(true);
        const tempData = await getData(`inventory/getVendorDetailsById?vendorId=${vendorId}`);
        setIsLoadingOn(false);
        if (tempData?.statusCode === 200) {
            const records = tempData?.data;
            setSelectedVendor(records[0])
            setFormData(records[0]);
        } else {
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors?.msg || "Something went wrong!!!"
            });
        }
    }

    async function getVendorList() {
        setIsLoadingOn(true);
        const tempData = await getData(`inventory/getVendor`);
        setIsLoadingOn(false);

        if (tempData?.statusCode === 200) {
            const records = tempData?.data?.records;
            if (Array.isArray(records)) {
                setVendorList(records || []);
            } else {
                setVendorList([]);
            }
        } else {
            setVendorList([]); 
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors?.msg || "Something went wrong!!!"
            });
        }
    }

    useEffect(() => {
        getVendorList(value);
    }, [value]);

    const handleVendorClick = (vendor) => {
        history.push(`/vendorDetails/${vendor.id}`);
    };

    const toggleSection = (sectionName) => {
        setCollapsedSections(prev => ({
            ...prev,
            [sectionName]: !prev[sectionName]
        }));
    };

    const openModal = (type) => {
        setModalType(type);
        setIsModalOpen(true);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setAddressInput(prev => ({ ...prev, [name]: value }));
    };
    
    useEffect(() => {
        if (isModalOpen) {
          const prefill = modalType === 'billing'
            ? {
                country: formData.billingCountry || 'India',
                address1: formData.billingAddessLine1 || '',
                address2: formData.billingAddessLine2 || '',
                city: formData.billingCity || '',
                state: formData.billingState || '',
                pinCode: formData.billingPincode || '',
                phoneNumber: formData.billingPhoneNumber || '',
                faxNumber: formData.billingFaxNumber || ''
              }
            : {
                country: formData.shippingCountry || 'India',
                address1: formData.shippingAddessLine1 || '',
                address2: formData.shippingAddessLine2 || '',
                city: formData.shippingCity || '',
                state: formData.shippingState || '',
                pinCode: formData.shippingPincode || '',
                phoneNumber: formData.shippingPhoneNumber || '',
                faxNumber: formData.shippingFaxNumber || ''
              };
      
          setAddressInput(prefill);
        }
    }, [isModalOpen, modalType]);    

    const renderChevron = (sectionName) => (
        collapsedSections[sectionName] ? <ChevronDown size={16} /> : <ChevronUp size={16} />
    );

    const toggleAccountVisibility = (index) => {
        setVisibleAccounts(prev => ({
          ...prev,
          [index]: !prev[index]
        }));
    };
    
    const handleBankInputChange = (field, value) => {
        setBankInput(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleAddContactPerson = async () => {
        const errors = {};
      
        if (!firstNameContact.trim()) {
          errors.firstNameContact = "First Name is required.";
        }
      
        if (!lastNameContact.trim()) {
          errors.lastNameContact = "Last Name is required.";
        }
      
        if (!mobileContact.trim()) {
          errors.mobileContact = "Mobile Number is required.";
        } else {
          const mobileRegex = /^[6-9]\d{9}$/;
          if (!mobileRegex.test(mobileContact)) {
            errors.mobileContact = "Please enter a valid 10-digit mobile number.";
          }
        }
      
        if (Object.keys(errors).length > 0) {
          setFormErrors(errors);
          return;
        }
      
        const newContact = {
          salutation: salutationData,
          firstName: firstNameContact,
          lastName: lastNameContact,
          email: emailContact,
          phoneNumber: workPhoneContact,
          mobileNumber: mobileContact,
          skypeLink: skypeLinkContact,
          designation: designationContact,
          department: departmentContact
        };
      
        const updatedContacts = [...formData.contactPersons, newContact];
      
        setFormData(prev => ({
          ...prev,
          contactPersons: updatedContacts
        }));
      
            await handleUpdateSubmit({ preventDefault: () => {} }, {
              contactPersons: updatedContacts
            });
            setShowContactModal(false);
    }

    useEffect(() => {
        if (showContactModal) {
          setContactSalutationData('');
          setContactFirstName('');
          setContactLastName('');
          setContactEmail('');
          setContactWorkPhone('');
          setContactMobile('');
          setContactSkypeLink('');
          setContactDesignation('');
          setContactDepartment('');
          setFormErrors({});
        }
    }, [showContactModal]);

    const handleAddBankDetail = async () => {
        if (!validateBankInput()) return;
    
        const newBankData = { ...bankInput };
        delete newBankData.confirmAccountNumber;
    
        const newBankList = [...formData.bankDetails, newBankData];
        setFormData(prev => ({
          ...prev,
          bankDetails: newBankList
        }));
    
        await handleUpdateSubmit({ preventDefault: () => {} }, {
            bankDetails: newBankList
        });
      
        setBankInput({
            accountHolderName: "",
            bankName: "",
            accountNumber: "",
            confirmAccountNumber: "",
            ifscCode: "",
            showAccount: false,
        });
        setShowBankDetailsModal(false);
    };

    useEffect(() => {
        if (showBankDetailsModal) {
            setBankInput({
                accountHolderName: "",
                bankName: "",
                accountNumber: "",
                confirmAccountNumber: "",
                ifscCode: "",
                showAccount: false,
            });
            setBankInputErrors({});
        }
    }, [showBankDetailsModal]);
      
    const handleSaveAddress = async () => {

        const errors = {};

        if (!/^\d{6}$/.test(addressInput.pinCode)) {
            errors.pinCode = "Pin Code must be a 6-digit number.";
        }

        if (!/^\d{10}$/.test(addressInput.phoneNumber)) {
            errors.phoneNumber = "Phone Number must be a 10-digit number.";
        }

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        const mapped = {
          [`${modalType}Country`]: addressInput.country,
          [`${modalType}AddessLine1`]: addressInput.address1,
          [`${modalType}AddessLine2`]: addressInput.address2,
          [`${modalType}City`]: addressInput.city,
          [`${modalType}State`]: addressInput.state,
          [`${modalType}Pincode`]: addressInput.pinCode,
          [`${modalType}PhoneNumber`]: addressInput.phoneNumber,
          [`${modalType}FaxNumber`]: addressInput.faxNumber,
        };
    
        setFormData(prev => ({ ...prev, ...mapped }));
    
        if (modalType === 'billing') {
          setBillingAddress(mapped);
        } else {
          setShippingAddress(mapped);
        }
    
        setIsModalOpen(false);
        setAddressJustSaved(true);
        await handleUpdateSubmit({ preventDefault: () => {} }, mapped);

        setAddressInput({
          country: '',
          address1: '',
          address2: '',
          city: '',
          state: '',
          pinCode: '',
          phoneNumber: '',
          faxNumber: ''
        });
        setFormErrors({});
    };

    useEffect(() => {
        if (addressJustSaved) {
          handleUpdateSubmit({ preventDefault: () => {} });
          setAddressJustSaved(false);
        }
    }, [formData, addressJustSaved]);
    
    useEffect(() => {
        const mapped = {
            billingCountry: billingAddress.billingCountry || 'India',
            billingAddessLine1: billingAddress.billingAddessLine1 || '',
            billingAddessLine2: billingAddress.billingAddessLine2 || '',
            billingCity: billingAddress.billingCity || '',
            billingState: billingAddress.billingState || '',
            billingPincode: billingAddress.billingPincode || '',
            billingPhoneNumber: billingAddress.billingPhoneNumber || '',
            billingFaxNumber: billingAddress.billingFaxNumber || ''
        };
        setFormData(prev => ({ ...prev, ...mapped }));
    }, [billingAddress]);
    
    useEffect(() => {
        const mapped = {
            shippingCountry: shippingAddress.shippingCountry || 'India',
            shippingAddessLine1: shippingAddress.shippingAddessLine1 || '',
            shippingAddessLine2: shippingAddress.shippingAddessLine2 || '',
            shippingCity: shippingAddress.shippingCity || '',
            shippingState: shippingAddress.shippingState || '',
            shippingPincode: shippingAddress.shippingPincode || '',
            shippingPhoneNumber: shippingAddress.shippingPhoneNumber || '',
            shippingFaxNumber: shippingAddress.shippingFaxNumber || ''
        };
        setFormData(prev => ({ ...prev, ...mapped }));
    }, [shippingAddress]);    
    
    const copyBillingToShipping = () => {
        const mapped = {
            shippingCountry: formData.billingCountry || 'India',
            shippingAddessLine1: formData.billingAddessLine1 || '',
            shippingAddessLine2: formData.billingAddessLine2 || '',
            shippingCity: formData.billingCity || '',
            shippingState: formData.billingState || '',
            shippingPincode: formData.billingPincode || '',
            shippingPhoneNumber: formData.billingPhoneNumber || '',
            shippingFaxNumber: formData.billingFaxNumber || ''
        };
        setIsLoadingOn(true);
        setFormData(prev => ({ ...prev, ...mapped }));
        setShippingAddress(mapped);
        setAddressJustSaved(true);
    };
    
    const validateForm = () => {
        const errors = {};

        if (!formData.firstName.trim()) {
            errors.firstName = "First Name is required.";
        }
        if (!formData.lastName.trim()) {
            errors.lastName = "Last Name is required.";
        }
        if (!formData.companyName.trim()) {
            errors.companyName = "Company Name is required.";
        }
        if (!formData.displayName.trim()) {
            errors.displayName = "Display Name is required.";
        }
        if (!formData.mobileNumber.trim()) {
            errors.mobileNumber = "Mobile Number is required.";
        } else {
            const mobileRegex = /^[6-9]\d{9}$/;
            if (!mobileRegex.test(formData.mobileNumber)) {
                errors.mobileNumber = "Please enter a valid 10-digit mobile number.";
            }
        }
        if (isPortalAccessEnabled === "Yes") {
            if (!formData.email) {
                errors.email = "Email is required.";
            } else {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(formData.email)) {
                    errors.email = "Please enter a valid email address.";
                }
            }
        }
        

        setFormErrors(errors);
        if (Object.keys(errors).length > 0) {
            const errorList = Object.values(errors)
              .map(msg => `• ${msg}`)
              .join("<br>");
        
            Swal.fire({
              icon: "warning",
              title: "Validation Error",
              html: errorList,
              confirmButtonColor: "#3085d6"
            });
        
            return false;
          }
        return true;
        // return Object.keys(errors).length === 0;
    };

    const validateBankInput = () => {
        const errors = {};
        if (!bankInput.accountHolderName.trim()) errors.accountHolderName = "Account Holder Name is required.";
        if (!bankInput.bankName.trim()) errors.bankName = "Bank Name is required.";
        if (!bankInput.accountNumber.trim()) errors.accountNumber = "Account Number is required.";
        if (!bankInput.ifscCode.trim()) {
            errors.ifscCode = "IFSC Code is required.";
        } else {
            const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
            if (!ifscRegex.test(bankInput.ifscCode.trim().toUpperCase())) {
                errors.ifscCode = "Please enter a valid IFSC code.";
            }
        }
        if (
            bankInput.accountNumber.trim() &&
            bankInput.confirmAccountNumber.trim() &&
            bankInput.accountNumber !== bankInput.confirmAccountNumber
        ) {
            errors.confirmAccountNumber = "Account numbers do not match.";
        }
        
        setBankInputErrors(errors);
        return Object.keys(errors).length === 0;
    };

    console.log("formErrors", formErrors);
   
    const handleUpdateSubmit = async (e, updatedFields = {}) => {
        e.preventDefault?.();
        setIsLoadingOn(true);

        const isValid = validateForm();
    
        if (!isValid) {
          setIsLoadingOn(false);
          return;
        }
      
        const finalData = {
          ...formData,
          ...updatedFields
        };

        const cleanedBankDetails = (finalData.bankDetails || []).map(bank => {
            const { confirmAccountNumber, ...rest } = bank;
            return rest;
        });
      
        const filterData = {
          vendorId: finalData.id,
          salutation: finalData.salutation,
          firstName: finalData.firstName,
          lastName: finalData.lastName,
          companyName: finalData.companyName,
          displayName: finalData.displayName,
          email: finalData.email,
          phoneNumber: finalData.phoneNumber,
          mobileNumber: finalData.mobileNumber,
          panNumber: finalData.panNumber,
          gstNumber: finalData.gstNumber,
          uinNumber: finalData.uinNumber,
          isMsmeRegistered: finalData.isMsmeRegistered,
          udyamRegistrationType: finalData.udyamRegistrationType,
          udyamRegistrationNumber: finalData.udyamRegistrationNumber,
          department: finalData.department,
          designation: finalData.designation,
          currency: finalData.currency,
          paymentTerms: finalData.paymentTerms,
          tds: finalData.tds,
          isPortalAccessEnabled: finalData.isPortalAccessEnabled,
          language: finalData.language,
          documentPath: finalData.documentPath,
          websiteUrl: finalData.websiteUrl,
          tweeterLink: finalData.tweeterLink,
          facebookLink: finalData.facebookLink,
          skypeLink: finalData.skypeLink,
          remarks: finalData.remarks,
          billingCountry: finalData.billingCountry,
          billingAddessLine1: finalData.billingAddessLine1,
          billingAddessLine2: finalData.billingAddessLine2,
          billingCity: finalData.billingCity,
          billingState: finalData.billingState,
          billingPincode: finalData.billingPincode,
          billingPhoneNumber: finalData.billingPhoneNumber,
          billingFaxNumber: finalData.billingFaxNumber,
          shippingCountry: finalData.shippingCountry,
          shippingAddessLine1: finalData.shippingAddessLine1,
          shippingAddessLine2: finalData.shippingAddessLine2,
          shippingCity: finalData.shippingCity,
          shippingState: finalData.shippingState,
          shippingPincode: finalData.shippingPincode,
          shippingPhoneNumber: finalData.shippingPhoneNumber,
          shippingFaxNumber: finalData.shippingFaxNumber,
          contactPersons: finalData.contactPersons,
          bankDetails: cleanedBankDetails,
          updatedBy: employeeId
        };
      
        try {
          const res = await postData(`inventory/updateVendor`, filterData);
          setIsLoadingOn(false);
      
          if (res.statusCode === 200) {
            Swal.fire({
              icon: "success",
              title: "Success!",
              text: "Data Updated successfully!",
              timer: 3000,
              showConfirmButton: false,
            });
            setIsModalOpen(false);
            setTimeout(() => {
                setShowTopMessage(false);
                window.location.reload();
            }, 3000);
          } else {
            Swal.fire({
              icon: "error",
              title: "Error!",
              text: res.message || "Something went wrong!",
            });
          }
        } catch (err) {
          setIsLoadingOn(false);
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "Something went wrong during submission.",
          });
        }
    };

    const handlePinCodeChange = async (value, type) => {
        if (value.length === 6) {
            setIsLoadingOn(true);
            let res = await getData(`users/getCityStateByPincode/${value}`);
            setIsLoadingOn(false);
    
            if (res.statusCode === 200 && Array.isArray(res.data) && res.data.length > 0) {
                const { district, stateName } = res.data[0];
                const updatedFields = {
                    city: district,
                    state: stateName,
                };
    
                setAddressInput(prev => ({
                    ...prev,
                    ...updatedFields,
                }));
    
                const formFieldMapping = {
                    [`${type}City`]: district,
                    [`${type}State`]: stateName,
                    [`${type}Country`]: 'India',
                };
    
                if (type === 'billing') {
                    setBillingAddress(prev => ({ ...prev, ...formFieldMapping }));
                } else {
                    setShippingAddress(prev => ({ ...prev, ...formFieldMapping }));
                }
    
                setFormData(prev => ({
                    ...prev,
                    ...formFieldMapping,
                }));
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error!",
                    text: "Invalid Pin Code",
                });
                setAddressInput(prev => ({
                    ...prev,
                    city: '',
                    state: ''
                }));
            }
        }
    };
      
    console.log("formData == ", formData);

    return (
        <div>
            <div className="top-bar">
                <div className="left-section">
                    <button className="refresh-btn" onClick={() => getVendorList()}>⟳</button>
                    <div className="search-container">
                        <Search size={20} className="search-icon" />
                        <input
                            type="text"
                            placeholder="Search Vendors"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                    </div>
                </div>

                {/* <div className="right-section">
                    <button className="plus-btn"><Plus size={16} /></button>
                    <button className="menu-btn">⋮</button>
                    <button className="edit-btn">Edit</button>
                    <button className="attachment-btn">📎</button>
                    <button className="new-transaction-btn">New Transaction <ChevronDown size={16} /></button>
                    <button className="more-btn">More <ChevronDown size={16} /></button>
                    <button className="close-btn">✕</button>
                </div> */}
            </div>
            <div className="vendor-details-wrapper" style={{ display: 'flex'}}>
                {isLoadingOn && <Loader />}

                <div className="vendor-sidebar">
                    <div className="sidebar-header">
                        <h5>Vendors</h5>
                        {/* <Link to="/addNewVendor">
                            <button className="btn btn-primary">+ New</button>
                        </Link> */}
                    </div>
                    <div className="vendor-list">
                        {vendorList.map((item) => (
                            <div
                                key={item.id}
                                className={`vendor-item ${selectedVendor?.id === item.id ? "active" : ""}`}
                                onClick={() => handleVendorClick(item)}
                            >
                                <div className="vendor-name">{item.companyName}</div>
                                <div className="vendor-balance">Rs.{item?.orderTotal ? Number(item.orderTotal).toFixed(2) : '0.00'}</div>
                            </div>
                        ))}
                    </div>
                </div>
        
                <div className="vendor-detail-section" style={{ flex: 1, overflowY: 'auto' }}>
                    <div className="vendor-header" style={{ borderBottom: '1px solid #ccc'}}>
                        <div className="vendor-header-row">
                            <h3 className="vendor-header-title">
                                {selectedVendor?.companyName || "Vendor Details"}
                            </h3>
                            <Link to={`/UpdateVendor/${selectedVendor?.id}`}>
                                <button className="edit-btn">Edit</button>
                            </Link>
                        </div>
                        <div className="tab-buttons">
                            {["Overview", "Comments", "Transactions", "Mails", "Statement"].map(tab => (
                                <button
                                    key={tab}
                                    className={`tab-button ${activeTab === tab ? "active" : ""}`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                    </div>
        
                    <div className="tab-content"    >
                        {activeTab === "Overview" && selectedVendor && (
                            <div className="vendor-overview-wrapper" style={{ display: 'flex', gap: '2rem' }}>
                                <div className="vendor-overview-left" style={{ flex: 1 }}>
                                    <h5>{selectedVendor.companyName}</h5>

                                    <div className="vendor-profile">
                                        <div className="profile-pic" />
                                        <div className="profile-details">
                                            <h5>{selectedVendor.vendorName}</h5>
                                            <p>{selectedVendor.email}</p>
                                            <p>📞 {selectedVendor.phoneNumber}</p>
                                            <p>📱 {selectedVendor.mobileNumber}</p>
                                        </div>
                                    </div>

                                    <div className="section">
                                        <div className="section-header" onClick={() => toggleSection('ADDRESS')}>
                                            <h6>ADDRESS</h6>
                                            {renderChevron('ADDRESS')}
                                        </div>
                                        {!collapsedSections['ADDRESS'] && (
                                            <>
                                            {/* Billing Address */}
                                            <div style={{ marginBottom: '1rem' }}>
                                                <p><strong>Billing Address</strong>
                                                {formData.billingAddessLine1 ? (
                                                    <>
                                                    <span style={{ float: 'right', cursor: 'pointer' }} onClick={() => openModal('billing')}>
                                                        ✏️
                                                    </span>
                                                    <br />
                                                    {formData.billingAddessLine1},<br />
                                                    {formData.billingAddessLine2},<br />
                                                    {formData.billingCity},<br />
                                                    {formData.billingState}, {formData.billingPincode}<br />
                                                    {formData.billingCountry}<br />
                                                    Phone : {formData.billingPhoneNumber || "-"} <br />
                                                    Fax Number : {formData.billingFaxNumber || "-"}
                                                    </>
                                                ) : (
                                                    <>
                                                    <br />No Billing Address – 
                                                    <a href="#" onClick={() => openModal('billing')}> + New Billing Address</a>
                                                    </>
                                                )}
                                                </p>
                                            </div>

                                            {/* Shipping Address */}
                                            <div>
                                                <p><strong>Shipping Address</strong>
                                                {formData.shippingAddessLine1 ? (
                                                    <>
                                                    <span style={{ float: 'right', cursor: 'pointer' }} onClick={() => openModal('shipping')}>
                                                        ✏️
                                                    </span>
                                                    <br />
                                                    {formData.shippingAddessLine1},<br />
                                                    {formData.shippingAddessLine2},<br />
                                                    {formData.shippingCity},<br />
                                                    {formData.shippingState}, {formData.shippingPincode}<br />
                                                    {formData.shippingCountry}<br />
                                                    Phone : {formData.shippingPhoneNumber || "-"} <br />
                                                    Fax Number : {formData.shippingFaxNumber || "-"}
                                                    </>
                                                ) : (
                                                    <>
                                                    <br />No Shipping Address – 
                                                    <a href="#" onClick={() => openModal('shipping')}> + New Shipping Address</a>
                                                    </>
                                                )}
                                                </p>
                                            </div>
                                            </>
                                        )}
                                    </div>

                                    <div className="section collapsible">
                                        <div className="section-header" onClick={() => toggleSection('OTHER')}>
                                            <h6>OTHER DETAILS</h6>
                                            {renderChevron('OTHER')}
                                        </div>
                                        {!collapsedSections['OTHER'] && (
                                            <div className="other-details-grid">
                                                <div className="row-item">
                                                    <p className="due-text">Default Currency:</p>
                                                    <div className="value-display">
                                                        <span>{selectedVendor.currency || "-"}</span>
                                                        {/* {editCurrency ? (
                                                            <>
                                                            <Select
                                                                options={CurrencyOptions}
                                                                defaultValue={CurrencyOptions.find(opt => opt.value === selectedVendor.currency)}
                                                                classNamePrefix="select"
                                                            />
                                                            <span className="close-icon" onClick={() => setEditCurrency(false)}>✕</span>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <span>{selectedVendor.currency || "-"}</span>
                                                                <Pencil size={14} className="edit-icon" onClick={() => setEditCurrency(true)} />
                                                            </>
                                                        )} */}
                                                    </div>
                                                </div>

                                                <div className="row-item">
                                                    <p className="due-text">Portal Status:</p>
                                                    <span className="value-display">{selectedVendor.isPortalAccessEnabled === 'Yes' ? 'Enabled' : 'Disabled'}</span>
                                                </div>

                                                <div className="row-item">
                                                    <p className="due-text">Portal Language:</p>
                                                    <div className="value-display">
                                                        <span>{selectedVendor.language || "-"}</span>
                                                        {/* {editLanguage ? (
                                                            <>
                                                            <Select
                                                                options={languageOptions}
                                                                defaultValue={languageOptions.find(opt => opt.value === selectedVendor.language)}
                                                                classNamePrefix="select"
                                                            />
                                                            <span className="close-icon" onClick={() => setEditLanguage(false)}>✕</span>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <span>{selectedVendor.language || "-"}</span>
                                                                <Pencil size={14} className="edit-icon" onClick={() => setEditLanguage(true)} />
                                                            </>
                                                        )} */}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <div className="section collapsible">
                                        <div className="section-header" onClick={() => toggleSection('CONTACT')}>
                                            <h6>CONTACT PERSONS</h6>
                                            <div className="icons">
                                                <button className="plus-button" onClick={() => setShowContactModal(true)}><Plus size={14} /></button>
                                                {renderChevron('CONTACT')}
                                            </div>
                                        </div>

                                        {!collapsedSections['CONTACT'] && (
                                            <div className="contact-card-list">
                                                {selectedVendor.contactPersons.length === 0 ? (
                                                <p>No contact persons added.</p>
                                                ) : (
                                                    selectedVendor.contactPersons.map((person, idx) => (
                                                    <div className="contact-card" key={idx}>
                                                    <div className="contact-avatar">
                                                    <img
                                                        src="https://www.w3schools.com/howto/img_avatar.png"
                                                        alt="Avatar"
                                                        className="avatar-img"
                                                    />
                                                    </div>
                                                    <div className="contact-details">
                                                        <strong>{`${person.salutation || ''} ${person.firstName} ${person.lastName}`}</strong>
                                                        <div>{person.email}</div>
                                                        <div>{person.designation}</div>
                                                        <div>{person.department}</div>
                                                        <div>📱 {person.mobileNumber}</div>
                                                        {/* <div className="portal-status">Portal invitation not accepted</div> */}
                                                    </div>
                                                    </div>
                                                ))
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    <div className="section collapsible">
                                        <div className="section-header" onClick={() => toggleSection('BANK')}>
                                            <h6>BANK ACCOUNT DETAILS</h6>
                                            <div className="icons">
                                                <button className="plus-button" onClick={(e) => {
                                                    e.stopPropagation();
                                                    setShowBankDetailsModal(true);
                                                }}>
                                                    <Plus size={14} />
                                                </button>
                                                {renderChevron('BANK')}
                                            </div>
                                        </div>

                                        {!collapsedSections['BANK'] && (
                                            <div className="bank-card-list">
                                                {selectedVendor.bankDetails.length == 0 ? (
                                                <p>No bank details added.</p>
                                                ) : (
                                                    selectedVendor.bankDetails.map((bank, idx) => (
                                                    <div className="bank-card" key={idx}>
                                                    <div className="bank-card-header">
                                                        <div className="bank-icon">🏦</div>
                                                        <div className="bank-info">
                                                        <strong>{bank.bankName}</strong>
                                                        <div className="account-number">
                                                            {visibleAccounts[idx]
                                                            ? bank.accountNumber
                                                            : `********${bank.accountNumber?.slice(-4)}`}
                                                            <span
                                                            className="view-toggle"
                                                            onClick={() => toggleAccountVisibility(idx)}
                                                            >
                                                            {visibleAccounts[idx] ? 'Hide' : 'View'}
                                                            </span>
                                                        </div>
                                                        </div>
                                                    </div>

                                                    <div className="bank-meta">
                                                        <div>
                                                            <strong>IFSC </strong>: {bank.ifscCode}
                                                        </div>
                                                        <div>
                                                            <strong>Account Holder Name </strong>: {bank.accountHolderName}
                                                        </div>
                                                    </div>
                                                    </div>
                                                ))
                                                )}
                                            </div>
                                        )}
                                    </div>  

                                    <div className="section collapsible">
                                        <div className="section-header" onClick={() => toggleSection('RECORD')}>
                                            <h6>RECORD INFO</h6>
                                            {renderChevron('RECORD')}
                                        </div>
                                        {!collapsedSections['RECORD'] && (
                                            <div className="other-details-grid">
                                                <div className="row-item">
                                                    <p className="due-text">Vendor ID </p>
                                                    <div className="value-display">
                                                        <span>{selectedVendor.id || "-"}</span>
                                                    </div>
                                                </div>

                                                <div className="row-item">
                                                    <p className="due-text">Created On</p>
                                                    <span className="value-display">{formatDateTime(selectedVendor.createdAt) || "-"}</span>
                                                </div>

                                                <div className="row-item">
                                                    <p className="due-text">Created By</p>
                                                    <div className="value-display">
                                                        <span>{selectedVendor.createdBy || "-"}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
        
                                <div className="vendor-overview-right">
                                    {/* <div className="what-next-box">
                                        <p><span>✨ WHAT’S NEXT?</span> <br />
                                        Create a <strong>purchase order</strong> or <strong>record a bill</strong> for your vendor purchases.</p>
                                        <div className="action-buttons">
                                        <button className="btn-primary">New Bill</button>
                                        <button className="btn-outline">New Purchase Order</button>
                                        </div>
                                    </div> */}
                                    <div style={{marginBottom: "50px"}}>
                                        <p className="due-text">Payment due period</p>
                                        <p>{selectedVendor.paymentTerms || "-"}</p>
                                    </div>

                                    <h5>Payables</h5>
                                    <div className="payables-table">
                                        <div className="payables-header">
                                        <span>CURRENCY</span>
                                        <span>OUTSTANDING PAYABLES</span>
                                        <span>UNUSED CREDITS</span>
                                        </div>
                                        <div className="payables-row">
                                        <span>{selectedVendor.currency}</span>
                                        <span>Rs.0.00</span>
                                        <span>Rs.0.00</span>
                                        </div>
                                    </div>

                                    <div className="items-info">
                                        <span>
                                            Items to be received: <span className="red">{selectedVendor.quantityToReceive || 0}</span>
                                        </span>
                                        <span className="divider">|</span>
                                        <span>
                                            Total items ordered: <span className="red">{selectedVendor.quantityOrdered || 0}</span>
                                        </span>
                                    </div>

                                    {selectedVendor.vendorActivityDetails && (
                                        <div className="activity-timeline">
                                            {selectedVendor.vendorActivityDetails.map((log, index) => (
                                            <div key={index} className="timeline-item">
                                                <div className="timeline-grid">
                                                {/* Left Side - Date/Time */}
                                                <div className="timeline-date">
                                                    <span>{new Date(log.createdAt).toLocaleDateString('en-GB')}</span>
                                                    <span>{new Date(log.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                                                </div>

                                                {/* Vertical Line */}
                                                <div className="timeline-line" />

                                                {/* Right Side - Content */}
                                                <div className="timeline-content">
                                                    <p className="activity-title">{log.actionPerform}</p>
                                                    <p className="activity-desc">{log.details.message}</p>
                                                    <p className="activity-meta">
                                                    by <strong>{log.createdByName}</strong>
                                                    {log.actionType === 'PURCHASE_ORDER' && (
                                                        <>
                                                        {" "}–{" "}
                                                        {log.referenceTable === 'PURCHASE_ORDER' && (
                                                            <span className="view-link" style={{ paddingLeft: "10px" }}>
                                                            <a href={`/purchaseorderDetails/${log.referenceId}`}>
                                                                View Details
                                                            </a>
                                                            </span>
                                                        )}
                                                        {log.referenceTable === 'PURCHASE_RECEIVE' && (
                                                            <span className="view-link" style={{ paddingLeft: "10px" }}>
                                                            <a href={`/purchasereceiveDetails/${log.referenceId}`}>
                                                                View Details
                                                            </a>
                                                            </span>
                                                        )}
                                                        </>
                                                    )}
                                                    </p>
                                                </div>
                                                </div>
                                            </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                        {activeTab !== "Overview" && (
                            <div className="coming-soon">Coming soon: {activeTab}</div>
                        )}
                    </div>

                    {showContactModal && (
                        <div className="modal-overlay">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4>Add Contact Person</h4>
                                    <X className="modal-close-icon" onClick={() => setShowContactModal(false)} />
                                </div>

                                <div className="modal-body">
                                    <div className="form-row">
                                    <label>Name</label>
                                    <div className="input-group triple">
                                        <div>
                                            <Select
                                                options={salutationOptions}
                                                placeholder="Salutation"
                                                style={{borderRadius: "6px"}}
                                                value={salutationOptions.find(opt => opt.value === salutationData)}
                                                onChange={(selectedOption) => {
                                                    setContactSalutationData(selectedOption?.value);
                                                }}
                                                isClearable
                                            />
                                        </div>
                                        <div>
                                            <input
                                                type="text"
                                                placeholder="First Name"
                                                value={firstNameContact}
                                                style={{borderRadius: "6px", width: "155px"}}
                                                onChange={(e) => {
                                                    setContactFirstName(e.target.value);
                                                }}
                                            />
                                            {formErrors.firstNameContact && (
                                                <small className="error-text">{formErrors.firstNameContact}</small>
                                            )}
                                        </div>
                                        <div>
                                            <input
                                                type="text"
                                                placeholder="Last Name"
                                                value={lastNameContact}
                                                style={{borderRadius: "6px", width: "160px"}}
                                                onChange={(e) => {
                                                    setContactLastName(e.target.value);
                                                }}
                                            />
                                            {formErrors.lastNameContact && (
                                                <small className="error-text">{formErrors.lastNameContact}</small>
                                            )}
                                        </div>
                                    </div>
                                    </div>

                                    <div className="form-row">
                                        <label>Email Address</label>
                                        <input
                                            type="email"
                                            className="input-field"
                                            value={emailContact}
                                            onChange={(e) => {
                                                setContactEmail(e.target.value);
                                            }}
                                        />
                                    </div>

                                    <div className="form-row">
                                        <label>Phone</label>
                                        <div className="input-group double">
                                            <div className="input-wrapper">
                                                <input
                                                    type="tel"
                                                    placeholder="Work Phone"
                                                    style={{width: "200px"}}
                                                    value={workPhoneContact}
                                                    onChange={(e) => {
                                                        setContactWorkPhone(e.target.value);
                                                    }}
                                                />
                                                {formErrors.phoneNumber && (
                                                    <small className="error-text">{formErrors.phoneNumber}</small>
                                                )}
                                            </div>
                                            <div className="input-wrapper">
                                                <input
                                                    type="tel"
                                                    placeholder="Mobile"
                                                    style={{width: "200px"}}
                                                    value={mobileContact}
                                                    onChange={(e) => {
                                                        setContactMobile(e.target.value);
                                                    }}
                                                />
                                                {formErrors.mobileContact && (
                                                    <small className="error-text">{formErrors.mobileContact}</small>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <label>Skype Name/Number</label>
                                        <input
                                            type="text"
                                            placeholder="Skype Name/Number"
                                            className="input-field"
                                            value={skypeLinkContact}
                                            onChange={(e) => setContactSkypeLink(e.target.value)}
                                        />
                                    </div>

                                    <div className="form-row">
                                        <label>Other Details</label>
                                        <div className="input-group double">
                                            <input
                                                type="designation"
                                                value={designationContact}
                                                placeholder="Designation"
                                                style={{borderRadius: "6px"}}
                                                onChange={(e) => {
                                                    setContactDesignation(e.target.value);
                                                }}
                                            />
                                            <input
                                                type="department"
                                                value={departmentContact}
                                                placeholder="Department"
                                                style={{borderRadius: "6px"}}
                                                onChange={(e) => {
                                                    setContactDepartment(e.target.value);
                                                }}
                                            />
                                        </div>
                                    </div>
                                            
                                    <hr></hr>
                                    <div className="checkbox-row">
                                        <input
                                            type="checkbox"
                                            id="enablePortal"
                                            checked={isPortalAccessEnabled === "Yes"}
                                            onChange={(e) => {
                                                setIsPortalAccessEnabled(e.target.checked ? "Yes" : "No");
                                                setFormData({ ...formData, isPortalAccessEnabled: e.target.checked ? "Yes" : "No" });
                                            }}
                                            style={{ marginRight: "4px" }}
                                        />
                                        <div>   
                                            <label htmlFor="portal-access">
                                                <strong>Enable vendor portal access</strong><br />
                                                <small>
                                                    This vendor will be able to see all their transactions with your organization by logging in to the portal using their email address. <a href="#">Learn More</a>
                                                </small>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-footer" style={{ justifyContent: "flex-start" }}>
                                    <button className="save-btn" onClick={handleAddContactPerson}>Save</button>
                                    <button className= "cancel-btn" onClick={() => setShowContactModal(false)}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    )}

                    {showBankDetailsModal && (
                        <div className="modal-overlay">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4>Add Bank Account Details</h4>
                                    <X className="modal-close-icon" onClick={() => setShowBankDetailsModal(false)} />
                                </div>

                                <div className="modal-body">
                                    <div className="form-row">
                                        <label>Account Holder Name</label>
                                        <input
                                            type="text"
                                            className="input-field"
                                            value={bankInput.accountHolderName}
                                            onChange={e => handleBankInputChange('accountHolderName', e.target.value)}
                                        />
                                        {bankInputErrors.accountHolderName && <p className="error-text">{bankInputErrors.accountHolderName}</p>}
                                    </div>

                                    <div className="form-row">
                                        <label>Bank Name</label>
                                        <input
                                            type="text"
                                            className="input-field"
                                            value={bankInput.bankName}
                                            onChange={e => handleBankInputChange('bankName', e.target.value)}
                                        />
                                        {bankInputErrors.bankName && <p className="error-text">{bankInputErrors.bankName}</p>}
                                    </div>

                                    <div className="form-row">
                                        <label style={{ color: "red" }}>Account Number*</label>
                                        <div className="input-icon-wrapper">
                                            <input
                                                type={showAccountNumber ? "text" : "password"}
                                                className="input-field"
                                                value={bankInput.accountNumber}
                                                onChange={e => handleBankInputChange('accountNumber', e.target.value)}
                                            />
                                            <span className="eye-icon" onClick={() => setShowAccountNumber(!showAccountNumber)}>
                                                {showAccountNumber ? <EyeOff size={16} /> : <Eye size={16} />}
                                            </span>
                                            {bankInputErrors.accountNumber && <p className="error-text">{bankInputErrors.accountNumber}</p>}
                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <label style={{ color: "red" }}>Confirm Account Number*</label>
                                        <div className="input-icon-wrapper">
                                            <input
                                                type={showConfirmNumber ? "text" : "password"}
                                                className="input-field"
                                                value={bankInput.confirmAccountNumber}
                                                onChange={e => handleBankInputChange('confirmAccountNumber', e.target.value)}
                                            />
                                            <span className="eye-icon" onClick={() => setShowConfirmNumber(!showConfirmNumber)}>
                                                {showConfirmNumber ? <EyeOff size={16} /> : <Eye size={16} />}
                                            </span>
                                            {bankInputErrors.confirmAccountNumber && <p className="error-text">{bankInputErrors.confirmAccountNumber}</p>}
                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <label style={{ color: "red" }}>IFSC Code*</label>
                                        <input
                                            type="text"
                                            className="input-field"
                                            value={bankInput.ifscCode}
                                            onChange={e => handleBankInputChange('ifscCode', e.target.value)}
                                        />
                                        {bankInputErrors.ifscCode && <p className="error-text">{bankInputErrors.ifscCode}</p>}
                                    </div>
                                </div>

                                <div className="modal-footer" style={{ justifyContent: "flex-start" }}>
                                    <button className="save-btn" onClick={handleAddBankDetail}>Save</button>
                                    <button className="cancel-btn" onClick={() => setShowBankDetailsModal(false)}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    )}

                    {isModalOpen && (
                        <div className="modal-overlay">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4>{modalType === 'billing' ? 'Add Billing Address' : 'Add Shipping Address'}</h4>
                                    <X className="modal-close-icon" onClick={() => setIsModalOpen(false)} />
                                </div>

                                <div className="modal-body">
                                    <div className="form-row"><label>Pin Code</label>
                                        <input 
                                            type="text" 
                                            name="pinCode" 
                                            maxLength={6}
                                            className={`input-field ${formErrors.pinCode ? 'input-error' : ''}`} 
                                            value={addressInput.pinCode} 
                                            onChange={(e) => {
                                                handleChange(e);
                                                const input = e.target.value;
                                                if (/^\d{6}$/.test(input)) {
                                                    handlePinCodeChange(input, modalType);
                                                }
                                            }} 
                                        />
                                        {formErrors.pincode && (
                                            <small className="error-text">{formErrors.pincode}</small>
                                        )}
                                    </div>
                                    <div className="form-row"><label>Country</label>
                                        <input
                                            type="text"
                                            name="country"
                                            className="input-field"
                                            value={addressInput.country}
                                            disabled
                                        />
                                    </div>
                                    <div className="form-row"><label>City</label>
                                        <input
                                            type="text"
                                            name="city"
                                            className="input-field"
                                            value={addressInput.city}
                                            readOnly
                                        />
                                    </div>

                                    <div className="form-row"><label>State</label>
                                        <input
                                            type="text"
                                            name="state"
                                            className="input-field"
                                            value={addressInput.state}
                                            readOnly
                                        />
                                    </div>
                                    <div className="form-row"><label>Address Line 1</label>
                                        <textarea name="address1" className="input-field" value={addressInput.address1} onChange={handleChange} />
                                    </div>
                                    <div className="form-row"><label>Address Line 2</label>
                                        <textarea name="address2" className="input-field" value={addressInput.address2} onChange={handleChange} />
                                    </div>
                                    <div className="form-row">
                                        <label>Phone Number</label>
                                        <input 
                                            type="text" 
                                            name="phoneNumber" 
                                            maxLength={10}
                                            className={`input-field ${!/^\d{10}$/.test(addressInput.phoneNumber) && addressInput.phoneNumber.length > 0 ? 'input-error' : ''}`} 
                                            value={addressInput.phoneNumber} 
                                            onChange={handleChange} 
                                        />
                                        {/^\d{10}$/.test(addressInput.phoneNumber) || addressInput.phoneNumber.length === 0 ? null : (
                                            <small className="error-text">Phone Number must be a 10-digit number.</small>
                                        )}
                                    </div>
                                    <div className="form-row"><label>Fax Number</label>
                                        <input type="text" name="faxNumber" className="input-field" value={addressInput.faxNumber} onChange={handleChange} />
                                    </div>

                                    {modalType === 'shipping' && (
                                        <div className="button-align-right">
                                            <button
                                                onClick={copyBillingToShipping}
                                                className="copy-btn"
                                                disabled={isLoadingOn}
                                            >
                                                {isLoadingOn ? 'Copying...' : 'Copy Billing → Shipping'}
                                            </button>
                                        </div>
                                    )}
                                </div>

                                <div className="modal-footer" style={{ justifyContent: "flex-start" }}>
                                    <button className="save-btn" onClick={handleSaveAddress}>Save</button>
                                    <button className="cancel-btn" onClick={() => setIsModalOpen(false)}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
}

export default VendorDetails;
